import collect from 'collect.js';
import useStorefront from './useStorefront';

const useStorefrontColors = (): {
  getColor: (color?: string | null) => string | undefined;
} => {
  const { store } = useStorefront();
  const getColor = (color?: string | null): string | undefined => {
    if (!color || !store) return undefined;
    if (color.includes('#') || color.includes('rgb')) return color;
    return collect(store.theme.is_dark_mode ? store.theme.dark_mode_color_variables : store.theme.color_variables).get(
      color,
    ) as string;
  };

  return {
    getColor,
  };
};

export default useStorefrontColors;
